import { ReactNode, Ref, useEffect, useState } from "react";
import { SvgIcon } from "@mui/material";
import { CoreButtonBase } from "@verity/components/core";
import i18n from "../../../../../i18n";
import styles from "./SingleVideoLayout.module.css";
import CaretLeft from "../../../../../images/caret-left.svg?react";
import CaretRight from "../../../../../images/caret-right.svg?react";

function NavigationButton({
	onClick,
	disabled,
	tooltip,
	disabledTooltip,
	children,
}: {
	onClick: () => void;
	disabled: boolean;
	tooltip: ReactNode;
	disabledTooltip: ReactNode;
	children: ReactNode;
}) {
	return (
		<CoreButtonBase
			className={styles.navigationButton}
			onClick={onClick}
			disabled={disabled}
			tooltip={tooltip}
			disabledTooltip={disabledTooltip}
			slotProps={{ tooltipWrapper: { className: styles.navigationButtonTooltipWrapper } }}
		>
			<SvgIcon>{children}</SvgIcon>
		</CoreButtonBase>
	);
}

export default function SingleVideoLayout({ videoRefs }: { videoRefs: Ref<HTMLDivElement>[] }) {
	const [page, setPage] = useState(0);
	useEffect(() => {
		if (page > 0 && page >= videoRefs.length) {
			setPage(videoRefs.length - 1);
		}
	}, [videoRefs]);

	const navigatePage = (offset: number) => setPage(Math.max(Math.min(page + offset, videoRefs.length - 1), 0));

	return (
		<div className={styles.videoContainer}>
			{videoRefs.map((ref, index) => (
				<div key={index} className={index === page ? styles.visibleVideo : styles.hiddenVideo} ref={ref} />
			))}
			{videoRefs.length > 1 && (
				<>
					<div className={styles.leftButtonWrapper}>
						<NavigationButton
							onClick={() => navigatePage(-1)}
							disabled={page === 0}
							tooltip={i18n.t(
								"result.components.studentSelection.videoPlayer.videoLayout.singleVideoLayout.left.tooltip",
							)}
							disabledTooltip={i18n.t(
								"result.components.studentSelection.videoPlayer.videoLayout.singleVideoLayout.left.disabledTooltip",
							)}
						>
							<CaretLeft />
						</NavigationButton>
					</div>
					<div className={styles.rightButtonWrapper}>
						<NavigationButton
							onClick={() => navigatePage(1)}
							disabled={page >= videoRefs.length - 1}
							tooltip={i18n.t(
								"result.components.studentSelection.videoPlayer.videoLayout.singleVideoLayout.right.tooltip",
							)}
							disabledTooltip={i18n.t(
								"result.components.studentSelection.videoPlayer.videoLayout.singleVideoLayout.right.disabledTooltip",
							)}
						>
							<CaretRight />
						</NavigationButton>
					</div>
				</>
			)}
		</div>
	);
}
